import { useQuery } from "@tanstack/react-query";
import Axios from "@/lib/axios-instance";

// API function
export const getPermissionByUserId = async (userId: string) => {
    if (!userId) throw new Error("User ID is required");

    try {
        const response = await Axios.get(`/user-permissions/user/${userId}`);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            return error?.response?.data;
        }
        throw new Error(error.message || "Network Error");
    }
};

// React Query hook
export const useGetPermissionByUserId = (userId: string | undefined) => {
    return useQuery({
        queryKey: ["get-permission-by-user-id", userId],
        queryFn: () => getPermissionByUserId(userId!),
        enabled: !!userId, // Only run if userId is truthy
    });
};
